import { inject, Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Pipe({ name: 'completedAgo' })
export class CompletedAgoPipe implements PipeTransform {
  private utils_service = inject(UtilsService);

  transform(value: string | Date | null | undefined): string {
    return this.utils_service.formatCompletedAgo(value);
  }
}
